import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy-900 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-131" data-mp="1jas22qc1cn10">
      <div className="mx-auto max-w-3xl px-4" data-id="element-132" data-mp="1s9n5xvrlxl15">
        <SectionHeading id="pricing-title" data-id="element-133" data-mp="1s8c25vy5wda1">Choose Your <span className="text-copper" data-id="element-134" data-mp="1x8qcjkn8jzb8">Option</span></SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-gold bg-navy-950 shadow-2xl shadow-black/50" data-id="element-135" data-mp="1x9hwtzbduam7">
          <div className="border-b border-gold/30 bg-navy-900/50 px-6 py-4 sm:px-10" data-id="element-136" data-mp="225gp3xzu0crw">
            <span className="inline-flex items-center gap-2 rounded-full border border-steel bg-steel/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-white" data-id="element-137" data-mp="2ws5npceffii">
              <AwardIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-138" data-mp="1mhzgt6bke99c" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-139" data-mp="1ho4zuancg8dy">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-140" data-mp="1cq3fzni3g51f">
              <div data-id="element-141" data-mp="17sjuc2j2gpzg">
                <h3 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-3xl" data-id="element-142" data-mp="17t39jbhc109s">{productShortName}</h3>
                <p className="mt-2 text-sm text-steel-light" data-id="element-143" data-mp="25d6bs7vdy1nz">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-144" data-mp="1vjfsrii12jfo">
                <span className="text-sm text-steel-light" data-id="element-145" data-mp="1rgj87m8xgd93">
                  Regular price: <span className="line-through decoration-gold decoration-2" data-id="element-146" data-mp="k1xz5bu5v06v">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-147" data-mp="g0cmnrljgnx7">Today:</p>
                <p className="mt-1 whitespace-nowrap text-5xl sm:text-6xl font-extrabold leading-none tracking-tight text-gold" data-id="element-148" data-mp="hhhzczxtm8cp">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} arrow className="mt-9 w-full" data-id="element-149" data-mp="7ju50b44n2v2">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-steel-light" data-id="element-150" data-mp="3uw4p2v0eooo4">
              {['Secure payment', 'Instant access', '7-day guarantee'].map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-151" data-mp="3kyqehc15yu3q">
                  <CheckCircle2Icon className="h-4 w-4 text-copper" aria-hidden="true" data-id="element-152" data-mp="3pxkyghavaopf" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}